import styled, { css, keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.4);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(82, 196, 26, 0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 48px;
  height: 100%;
  animation: ${fadeIn} 0.4s ease-out;
`;

export const StepsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 320px;
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  min-width: 70px;
`;

type StepStatus = 'completed' | 'active' | 'pending';

export const StepIndicator = styled.div<{ $status: StepStatus }>`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  flex-shrink: 0;

  ${({ $status, theme }) => {
    switch ($status) {
      case 'completed':
        return css`
          background: ${theme.colors.green6};
          color: white;
          border: none;
        `;
      case 'active':
        return css`
          background: white;
          color: ${theme.colors.green6};
          border: 2px solid ${theme.colors.green6};
          animation: ${pulse} 1.5s ease-in-out infinite;
        `;
      case 'pending':
      default:
        return css`
          background: ${theme.colors.black6};
          color: ${theme.colors.black4};
          border: none;
        `;
    }
  }}
`;

export const StepConnector = styled.div<{ $completed: boolean }>`
  height: 3px;
  width: 50px;
  margin-top: 20px;
  border-radius: 2px;
  flex-shrink: 0;
  background: ${({ $completed, theme }) =>
    $completed ? theme.colors.green6 : theme.colors.black5};
  transition: background 0.3s ease;
`;

export const StepLabel = styled.span<{ $status: StepStatus }>`
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  transition: color 0.3s ease;

  ${({ $status, theme }) => {
    switch ($status) {
      case 'completed':
        return css`
          color: ${theme.colors.green6};
        `;
      case 'active':
        return css`
          color: ${theme.colors.black4};
          font-weight: 600;
        `;
      case 'pending':
      default:
        return css`
          color: ${theme.colors.black7};
        `;
    }
  }}
`;

export const CurrentStepInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const CurrentStepTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
`;

export const CurrentStepDescription = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  max-width: 280px;
  line-height: 1.5;
`;
